import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f39f205"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-wrapper" }
const _hoisted_2 = ["id"]

import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import Text from '@/components/text'
import EZUIKit from 'ezuikit-js'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'single-video',
  props: ['id', 'name', 'accessToken', 'address'],
  setup(__props) {

const props = __props;

const t = i18n.global.t


const themeData = {
  header: {
    color: '#1890ff',
    activeColor: '#FFFFFF',
    backgroundColor: '#000000',
    btnList: [],
  },
  footer: {
    color: '#FFFFFF',
    activeColor: '#1890FF',
    backgroundColor: '#00000021',
    btnList: [
      {
        iconId: 'play',
        part: 'left',
        defaultActive: 1,
        memo: t('STATISTICS.bplay'),
        isrender: 1,
      },
      {
        iconId: 'capturePicture',
        part: 'left',
        defaultActive: 0,
        memo: t('STATISTICS.bscreenshotBtn'),
        isrender: 1,
      },
      {
        iconId: 'sound',
        part: 'left',
        defaultActive: 0,
        memo: t('STATISTICS.bsoundBtn'),
        isrender: 1,
      },
      {
        iconId: 'recordvideo',
        part: 'left',
        defaultActive: 0,
        memo: t('STATISTICS.brecordBtn'),
        isrender: 1,
      },
      {
        iconId: 'hd',
        part: 'right',
        defaultActive: 0,
        memo: t('STATISTICS.bhdBtn'),
        isrender: 1,
      },
      {
        iconId: 'webExpend',
        part: 'right',
        defaultActive: 0,
        memo: t('STATISTICS.bwebExpend'),
        isrender: 1,
      },
      {
        iconId: 'expend',
        part: 'right',
        defaultActive: 0,
        memo: t('STATISTICS.bexpendBtn'),
        isrender: 1,
      },
    ],
  },
}

const videoId = ref('single-video-')
onMounted(async () => {
  nextTick(() => {
    init()
  })
})
let player: any = null
const init = async () => {
  const { accessToken, address } = props
  player = new EZUIKit.EZUIKitPlayer({
    id: videoId.value + props.id, // 视频容器ID
    accessToken,
    url: address,
    width: 788,
    height: 443,
    // template: 'pcLive',
    themeData,
    handleError: (err: any) => {
      console.log(err)
    },
  })
}

onUnmounted(() => {
  try {
    player?.stop?.()
  } catch (error) {
    console.log(error)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "video",
      id: videoId.value + props.id
    }, null, 8, _hoisted_2),
    _createVNode(_unref(Text), {
      content: props.name
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.name), 1)
      ]),
      _: 1
    }, 8, ["content"])
  ]))
}
}

})